export reducer from './reducer';
export * as actions from './actions';

export FeedList from './components/FeedList';
export FeedTable from './components/FeedTable';
export LatestFeedList from './components/LatestFeedList';
export LatestFeedItem from './components/LatestFeedItem';



/** WEBPACK FOOTER **
 ** ./src/app/modules/feed/index.js
 **/